import { Action } from '@ngrx/store';




/* =======================
   Action Types
======================= */

export enum ActionTypes {

  /* ---- Get All Languages ---- */
  LOAD_ALL = '[Company Languages] Load All',
  LOAD_ALL_SUCCESS = '[Company Languages] Load All Success',
  LOAD_ALL_FAIL = '[Company Languages] Load All Fail',

  /* ---- Get Selected Languages ---- */
  LOAD_SELECTED = '[Company Languages] Load Selected',
  LOAD_SELECTED_SUCCESS = '[Company Languages] Load Selected Success',
  LOAD_SELECTED_FAIL = '[Company Languages] Load Selected Fail',

  /* ---- Add (POST) Selected Languages ---- */
  ADD = '[Company Languages] Add',
  ADD_SUCCESS = '[Company Languages] Add Success',
  ADD_FAIL = '[Company Languages] Add Fail',

  /* ---- Update (PUT) Selected Languages ---- */
  UPDATE = '[Company Languages] Update',
  UPDATE_SUCCESS = '[Company Languages] Update Success',
  UPDATE_FAIL = '[Company Languages] Update Fail',

  PASS_LANGUAGE_SET = '[Company Languages] Pass Language set'
}

/* =======================
   Pass Language 
   Pass language  translate component ts
======================= */


export class PassLanguageSet implements Action {
  readonly type = ActionTypes.PASS_LANGUAGE_SET;

  constructor(public payload: any) {}
}





/* =======================
   Load All Languages
   GET /company-languages
======================= */

export class LoadAll implements Action {
  readonly type = ActionTypes.LOAD_ALL;

  constructor(public companyId: number) {}
}

export class LoadAllSuccess implements Action {
  readonly type = ActionTypes.LOAD_ALL_SUCCESS;

  constructor(public response: any[]) {}
}

export class LoadAllFail implements Action {
  readonly type = ActionTypes.LOAD_ALL_FAIL;

  constructor(public error: any) {}
}

/* =======================
   Load Selected Languages
   GET /selected-company-languages
======================= */

export class LoadSelected implements Action {
  readonly type = ActionTypes.LOAD_SELECTED;

  constructor(public companyId: number | string) {}
}

export class LoadSelectedSuccess implements Action {
  readonly type = ActionTypes.LOAD_SELECTED_SUCCESS;

  constructor(public response: any[]) {}
}

export class LoadSelectedFail implements Action {
  readonly type = ActionTypes.LOAD_SELECTED_FAIL;

  constructor(public error: any) {}
}

/* =======================
   Add Selected Languages
   POST
   Payload:
   [
     { lang_name: 'English', lang_code: 'en' }
   ]
======================= */

export class Add implements Action {
  readonly type = ActionTypes.ADD;

  constructor(
    public companyId: number,
    public payload: any[]
  ) {}
}

export class AddSuccess implements Action {
  readonly type = ActionTypes.ADD_SUCCESS;
}

export class AddFail implements Action {
  readonly type = ActionTypes.ADD_FAIL;

  constructor(public error: any) {}
}

/* =======================
   Update Selected Languages
   PUT
   Same payload as POST
======================= */

export class Update implements Action {
  readonly type = ActionTypes.UPDATE;

  constructor(
    public companyId: number,
    public payload: any[]
  ) {}
}

export class UpdateSuccess implements Action {
  readonly type = ActionTypes.UPDATE_SUCCESS;
}

export class UpdateFail implements Action {
  readonly type = ActionTypes.UPDATE_FAIL;

  constructor(public error: any) {}
}

/* =======================
   Union Type
======================= */

export type Actions =
  | LoadAll
  | LoadAllSuccess
  | LoadAllFail
  | LoadSelected
  | LoadSelectedSuccess
  | LoadSelectedFail
  | Add
  | AddSuccess
  | AddFail
  | Update
  | UpdateSuccess
  | UpdateFail;
